import Raven from 'raven-js';
import { isArborHost } from './isArborHost';
export function reportError(error, {
  scope,
  extra,
  fingerprint
}) {
  if (isArborHost()) return;
  const errorObj = error instanceof Error ? error : new Error(String(error));
  Raven.captureException(errorObj, Object.assign({
    tags: {
      library_name: 'breeze-engine-lib'
    },
    extra: Object.assign({
      scope
    }, extra)
  }, fingerprint !== undefined ? {
    fingerprint
  } : {}));
}
export function reportWarning(message, {
  scope,
  extra,
  fingerprint
}) {
  if (isArborHost()) return;
  Raven.captureMessage(message, Object.assign({
    level: 'warning',
    tags: {
      library_name: 'breeze-engine-lib'
    },
    extra: Object.assign({
      scope
    }, extra)
  }, fingerprint !== undefined ? {
    fingerprint
  } : {}));
}